import { router, usePathname } from 'expo-router';
import { ScrollView, StyleSheet, View } from 'react-native';
import { Tabs } from '../../../components/primitives/Tabs';
import { useTranslation } from '../../../contexts/TranslationContext';
import { tokens } from '../../../theme/tokens';

/**
 * Top-level switcher between the Voice Agents list and the Calls inbox.
 * Both live under /voice-agents but had no cross-navigation — the calls inbox
 * was previously only reachable by typing the URL.
 */
export function VoiceSectionTabs() {
  const { t } = useTranslation();
  const pathname = usePathname();
  const onCalls = pathname?.startsWith('/voice-agents/calls') ?? false;
  const tabs = [
    { key: 'agents', label: t('voiceAgents.tabs.agents') },
    { key: 'calls', label: t('voiceAgents.tabs.calls') },
  ];

  return (
    <View style={styles.wrapper}>
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={styles.content}
      >
        <Tabs
          tabs={tabs}
          activeTab={onCalls ? 'calls' : 'agents'}
          onChange={(key) => {
            if (key === 'calls' && !onCalls) router.replace('/voice-agents/calls');
            if (key === 'agents' && onCalls) router.replace('/voice-agents');
          }}
          variant="pills"
          testID="voice-section-tabs"
        />
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    flexShrink: 0,
    minHeight: 46,
  },
  content: {
    alignItems: 'center',
    paddingVertical: tokens.spacing.xxs,
  },
});
